export const domain = (path?: string) =>
  `https://benali-eg.com${path ? "/" + path : ""}`;
// `https://qrscontracting.com${path ? "/" + path : ""}`;
// `https://react.hanstarcarrental.com${path ? "/" + path : ""}`;
// `https://egyptos-travel.com${path ? "/" + path : ""}`;
